import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import Icon, { Icons } from '@eversports/react-components/primitives/Icon'
import { Localized } from '../../localization/react'
import useMedicalCertificate, { MedicalCertificateStatus } from '../../data/useMedicalCertificate'

const bannerVariants = {
  [MedicalCertificateStatus.MISSING]: {
    messageKey: 'medical-certificate-missing',
    iconColor: 'warning.main',
    icon: Icons.WARNING,
    containerColor: '#FDF2E7',
  },
  [MedicalCertificateStatus.EXPIRING]: {
    messageKey: 'medical-certificate-expiring',
    iconColor: 'warning.main',
    icon: Icons.WARNING,
    containerColor: '#FDF2E7',
  },
  [MedicalCertificateStatus.EXPIRED]: {
    messageKey: 'medical-certificate-expired',
    iconColor: 'error.main',
    icon: Icons.ERROR,
    containerColor: '#FAF0F0',
  },
} as const

export const MedicalCertificateBanner = () => {
  const { loading, status, validityDate, enabled } = useMedicalCertificate()

  if (loading || !enabled || status === MedicalCertificateStatus.VALID) {
    return null
  }

  const variant = bannerVariants[status || MedicalCertificateStatus.MISSING]

  return (
    <Stack
      direction="row"
      spacing={2}
      marginBottom={2}
      sx={{ backgroundColor: '#FDF2E7', borderRadius: 1, padding: 2 }}
    >
      <Icon icon={variant.icon} color={variant.iconColor} size="large" />
      <Stack direction="column" spacing={1} justifyItems="center" alignItems="flex-start">
        <Text variant="large" sx={{ color: 'midnight', fontWeight: 'bold', fontSize: '16px' }}>
          <Localized id={variant.messageKey} params={{ validityDate }} />
        </Text>
        <Text is="span" variant="small" color="midnight">
          <Localized id="medical-certificate-reminder" />
        </Text>
      </Stack>
    </Stack>
  )
}
